(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-prod-k"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sections = document.querySelectorAll('[id^="FeaturedProdK-"]');

    sections.forEach((section) => {
      const productJson = section.querySelector('[data-fpk-product-json]');
      const configJson = section.querySelector('[data-fpk-config]');
      if (!productJson || !configJson) return;

      const product = JSON.parse(productJson.textContent);
      const config = JSON.parse(configJson.textContent);
      const form = section.querySelector('[data-fpk-form]');
      if (!form) return;

      const variantInput = form.querySelector('[data-fpk-variant-id]');
      const priceEl = section.querySelector('[data-fpk-price]');
      const compareEl = section.querySelector('[data-fpk-compare-price]');
      const submitBtn = form.querySelector('[data-fpk-submit]');
      const submitText = form.querySelector('[data-fpk-submit-text]');
      const saleBadge = section.querySelector('[data-fpk-sale-badge]');
      const mainImage = section.querySelector('[data-fpk-main-image]');
      const thumbs = section.querySelectorAll('[data-fpk-thumb]');
      const optionInputs = form.querySelectorAll('[data-fpk-option-input]');
      const qtyInput = form.querySelector('[data-fpk-qty-input]');
      const qtyMinus = form.querySelector('[data-fpk-qty-minus]');
      const qtyPlus = form.querySelector('[data-fpk-qty-plus]');

      const moneyFormat = config.moneyFormat;

      const formatMoney = (cents) => {
        if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
          return window.Shopify.formatMoney(cents, moneyFormat);
        }
        return (cents / 100).toFixed(2);
      };

      const getSelectedOptions = () => {
        const options = [];
        product.options.forEach((name, index) => {
          const position = index + 1;
          const inputs = form.querySelectorAll(`[data-fpk-option-input][data-option-position="${position}"]`);
          let value = null;

          inputs.forEach((input) => {
            if (input.type === 'radio') {
              if (input.checked) value = input.value;
            } else {
              value = input.value;
            }
          });

          options.push(value);

          const display = section.querySelector(`[data-fpk-option-display="${position}"]`);
          if (display && value) display.textContent = value;
        });
        return options;
      };

      const findVariant = () => {
        const selected = getSelectedOptions();
        return product.variants.find((variant) =>
          variant.options.every((value, index) => value === selected[index])
        );
      };

      const setActiveThumb = (mediaId) => {
        thumbs.forEach((thumb) => {
          const isActive = String(thumb.dataset.mediaId) === String(mediaId);
          thumb.classList.toggle('is-active', isActive);
          thumb.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });
      };

      const updateMainImage = (src, alt, mediaId) => {
        if (!mainImage || !src) return;
        mainImage.classList.add('is-fading');
        mainImage.onload = () => mainImage.classList.remove('is-fading');
        mainImage.src = src;
        if (alt) mainImage.alt = alt;
        if (mediaId) setActiveThumb(mediaId);
      };

      const updateVariantUI = (variant) => {
        if (!variant) return;

        if (variantInput) variantInput.value = variant.id;

        if (priceEl) priceEl.textContent = formatMoney(variant.price);

        if (compareEl) {
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            compareEl.textContent = formatMoney(variant.compare_at_price);
            compareEl.classList.remove('hidden');
          } else {
            compareEl.textContent = '';
            compareEl.classList.add('hidden');
          }
        }

        if (saleBadge) {
          saleBadge.hidden = !(variant.compare_at_price && variant.compare_at_price > variant.price);
        }

        if (submitBtn) submitBtn.disabled = !variant.available;
        if (submitText) {
          submitText.textContent = variant.available
            ? config.addToCartLabel
            : config.soldOutLabel;
        }

        if (variant.featured_media) {
          const mediaId = variant.featured_media.id;
          const thumb = section.querySelector(`[data-fpk-thumb][data-media-id="${mediaId}"]`);
          const preview = variant.featured_media.preview_image;
          const src = thumb ? thumb.dataset.mediaSrc : (preview ? preview.src : null);
          const alt = thumb ? thumb.dataset.mediaAlt : mainImage?.alt;
          if (src) updateMainImage(src, alt, mediaId);
        }
      };

      if (submitText) {
        submitText.dataset.availableLabel = config.addToCartLabel;
        submitText.dataset.soldOutLabel = config.soldOutLabel;
      }

      optionInputs.forEach((input) => {
        input.addEventListener('change', () => {
          const variant = findVariant();
          updateVariantUI(variant);
        });
      });

      thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => {
          updateMainImage(thumb.dataset.mediaSrc, thumb.dataset.mediaAlt, thumb.dataset.mediaId);
        });
      });

      if (qtyMinus && qtyInput) {
        qtyMinus.addEventListener('click', () => {
          const current = parseInt(qtyInput.value, 10) || 1;
          qtyInput.value = Math.max(1, current - 1);
        });
      }

      if (qtyPlus && qtyInput) {
        qtyPlus.addEventListener('click', () => {
          const current = parseInt(qtyInput.value, 10) || 1;
          qtyInput.value = current + 1;
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews-k"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initReviewsSlider = (section) => {
      if (!section || section.dataset.rkInitialized === 'true') return;

      const viewport = section.querySelector('[data-rk-viewport]');
      const track = section.querySelector('[data-rk-track]');
      const slides = Array.from(section.querySelectorAll('[data-rk-slide]'));
      const prevBtn = section.querySelector('[data-rk-prev]');
      const nextBtn = section.querySelector('[data-rk-next]');
      const dotsWrap = section.querySelector('[data-rk-dots]');

      if (!viewport || !track || slides.length === 0) return;

      section.dataset.rkInitialized = 'true';

      const config = {
        sliderDesktop: section.dataset.sliderDesktop === 'true',
        sliderMobile: section.dataset.sliderMobile === 'true',
        autoplay: section.dataset.autoplay === 'true',
        autoplaySpeed: parseInt(section.dataset.autoplaySpeed, 10) || 5000,
        showDots: section.dataset.showDots === 'true'
      };

      let index = 0;
      let slidesPerView = 1;
      let maxIndex = 0;
      let autoplayTimer = null;
      let touchStartX = 0;
      let touchDeltaX = 0;

      const isSliderActive = () => {
        const desktop = window.matchMedia('(min-width: 990px)').matches;
        return desktop ? config.sliderDesktop : config.sliderMobile;
      };

      const getSlidesPerView = () => {
        const desktop = window.matchMedia('(min-width: 990px)').matches;
        const styles = getComputedStyle(section);
        const raw = desktop
          ? styles.getPropertyValue('--rk-slides-desktop')
          : styles.getPropertyValue('--rk-slides-mobile');
        const value = parseInt(raw, 10);
        return Number.isFinite(value) && value > 0 ? value : 1;
      };

      const getGap = () => {
        const styles = getComputedStyle(track);
        return parseFloat(styles.columnGap || styles.gap) || 0;
      };

      const setSlideSizes = () => {
        const gap = getGap();
        const viewportWidth = viewport.clientWidth;
        slidesPerView = isSliderActive() ? getSlidesPerView() : slides.length;
        const slideWidth = (viewportWidth - gap * (slidesPerView - 1)) / slidesPerView;

        slides.forEach((slide) => {
          slide.style.flexBasis = `${slideWidth}px`;
          slide.style.width = `${slideWidth}px`;
          slide.style.maxWidth = `${slideWidth}px`;
        });
      };

      const buildDots = () => {
        if (!dotsWrap || !config.showDots || !isSliderActive()) {
          if (dotsWrap) dotsWrap.innerHTML = '';
          return;
        }

        const pages = Math.max(1, maxIndex + 1);
        if (dotsWrap.childElementCount === pages) return;

        dotsWrap.innerHTML = '';
        for (let i = 0; i < pages; i += 1) {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'reviews-k__dot';
          dot.setAttribute('aria-label', `Go to review ${i + 1}`);
          dot.addEventListener('click', () => {
            index = Math.min(i, maxIndex);
            updateLayout();
            restartAutoplay();
          });
          dotsWrap.appendChild(dot);
        }
      };

      const setActiveDot = () => {
        if (!dotsWrap) return;
        dotsWrap.querySelectorAll('.reviews-k__dot').forEach((dot, i) => {
          dot.classList.toggle('is-active', i === index);
          dot.setAttribute('aria-selected', i === index ? 'true' : 'false');
        });
      };

      const updateLayout = () => {
        const sliderOn = isSliderActive();
        slidesPerView = sliderOn ? getSlidesPerView() : slides.length;
        maxIndex = Math.max(0, slides.length - slidesPerView);
        if (index > maxIndex) index = maxIndex;

        slides.forEach((slide) => {
          slide.style.flexBasis = '';
          slide.style.width = '';
          slide.style.maxWidth = '';
        });

        if (!sliderOn) {
          track.style.transform = 'none';
          if (prevBtn) prevBtn.disabled = true;
          if (nextBtn) nextBtn.disabled = true;
          if (dotsWrap) dotsWrap.innerHTML = '';
          return;
        }

        setSlideSizes();

        const targetSlide = slides[index];
        const offset = targetSlide ? targetSlide.offsetLeft : 0;
        track.style.transform = `translate3d(-${offset}px, 0, 0)`;

        if (prevBtn) prevBtn.disabled = false;
        if (nextBtn) nextBtn.disabled = false;

        buildDots();
        setActiveDot();
      };

      const goNext = () => {
        if (!isSliderActive()) return;
        index = index >= maxIndex ? 0 : index + 1;
        updateLayout();
      };

      const goPrev = () => {
        if (!isSliderActive()) return;
        index = index <= 0 ? maxIndex : index - 1;
        updateLayout();
      };

      const restartAutoplay = () => {
        if (autoplayTimer) clearInterval(autoplayTimer);
        if (!config.autoplay || !isSliderActive()) return;
        autoplayTimer = setInterval(goNext, config.autoplaySpeed);
      };

      if (prevBtn) {
        prevBtn.addEventListener('click', (event) => {
          event.preventDefault();
          goPrev();
          restartAutoplay();
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', (event) => {
          event.preventDefault();
          goNext();
          restartAutoplay();
        });
      }

      viewport.addEventListener('touchstart', (event) => {
        if (!isSliderActive()) return;
        touchStartX = event.touches[0].clientX;
        touchDeltaX = 0;
      }, { passive: true });

      viewport.addEventListener('touchmove', (event) => {
        if (!isSliderActive()) return;
        touchDeltaX = event.touches[0].clientX - touchStartX;
      }, { passive: true });

      viewport.addEventListener('touchend', () => {
        if (!isSliderActive() || Math.abs(touchDeltaX) < 40) return;
        if (touchDeltaX < 0) goNext();
        else goPrev();
        restartAutoplay();
      });

      section.addEventListener('mouseenter', () => {
        if (autoplayTimer) clearInterval(autoplayTimer);
      });

      section.addEventListener('mouseleave', restartAutoplay);

      if (window.ResizeObserver) {
        const observer = new ResizeObserver(() => updateLayout());
        observer.observe(viewport);
      } else {
        window.addEventListener('resize', updateLayout);
      }

      requestAnimationFrame(() => {
        updateLayout();
        restartAutoplay();
      });
    };

    const boot = () => {
      document.querySelectorAll('[data-rk-slider]').forEach(initReviewsSlider);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', (event) => {
      const section = event.target.matches('[data-rk-slider]')
        ? event.target
        : event.target.querySelector('[data-rk-slider]');
      if (section) {
        delete section.dataset.rkInitialized;
        initReviewsSlider(section);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
